import { jsx as _jsx } from "react/jsx-runtime";
import legalDocuments from '@phishtool/legal-documents';
import Legal from '~components/legal';
const SecurityAndComplianceOverview = () => (_jsx(Legal, { heading: "Security and Compliance Overview", content: legalDocuments.securityAndComplianceOverview }));
export default SecurityAndComplianceOverview;
